import { useQueryClient } from '@tanstack/react-query';
import { useOverlayContext } from "../../../contexts";
import { QueryKeys } from "../../../hooks/reactQuery/queryKeys";
import { handleRequest } from "../../../infra/utils";
import { legalTermsModel } from "../../../models";
import { useAppConfig, useStoreActions } from "../../../store/store-context";
import { CreateDocumentModal } from "../CreateDocumentModal/CreateDocumentModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const useCreateQuillLegalTerms = () => {
  const {
    api
  } = useStoreActions();
  const queryClient = useQueryClient();
  const {
    showModal,
    showSuccessToast,
    showErrorToast
  } = useOverlayContext();
  const {
    generateUniqueId
  } = useAppConfig();
  const onModalConfirm = async (name, content) => {
    var _content$value;
    const id = generateUniqueId('legalTerms');
    const contentString = content ? JSON.stringify(content.value) : '';
    const result = await handleRequest(api.business.createQuillLegalTerms({
      id,
      name,
      content: contentString
    }));
    if (!result.success) {
      showErrorToast('An unknown error has occurred.');
      return;
    }
    showSuccessToast('Document created successfully');
    return legalTermsModel.makeQuillLegalTerms({
      id,
      name,
      origin: 'custom',
      richTextContent: (_content$value = content === null || content === void 0 ? void 0 : content.value) !== null && _content$value !== void 0 ? _content$value : []
    });
  };
  const createQuillLegalTerms = async () => {
    try {
      const newLegalTerms = await showModal({
        closeOnEscapeKey: true,
        closeOnClickOutside: true,
        content: _ref => {
          let {
            dismissModal
          } = _ref;
          return /*#__PURE__*/_jsx(CreateDocumentModal, {
            onConfirm: onModalConfirm,
            dismissModal: dismissModal
          });
        }
      });
      if (!newLegalTerms) {
        return;
      }
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.LegalTerms]
      });
      return newLegalTerms;
    } catch (_unused) {
      return undefined;
    }
  };
  return {
    createQuillLegalTerms
  };
};